import { Currency } from '@nemuru-eng/js-api-client';

import { setConfigStateById } from '../ConfigContext';

export const setLocaleCurrency = (setState: setConfigStateById) => (localeCurrency: Currency) => {
  setState('SET_LOCALE_CURRENCY', (s) => ({
    ...s,
    localeCurrency,
  }));
};
